
import { AssessmentQuestionGroupInterface } from './assessment-question-group.model';

export interface AssessmentPageInterface {
  id?: string;
  questionGroups?: AssessmentQuestionGroupInterface[];
  title?: string;
  subTitle?: string;
}

export class AssessmentPage implements AssessmentPageInterface {
  public id?: string;
  public questionGroups?: AssessmentQuestionGroupInterface[];
  public title?: string;
  public subTitle?: string;

  constructor({
    id = undefined,
    questionGroups = undefined,
    title = undefined,
    subTitle = undefined,
    }: AssessmentPageInterface) {
    this.id = id;
    this.questionGroups = questionGroups;
    this.title = title;
    this.subTitle = subTitle;
  }
}
